<template>
  <div class="tw:w-full">
    <div class="tw:flex tw:border-b tw:border-gray-300 tw:mx-4">
      <component
        v-for="tab in tabs"
        :key="tab.id"
        :is="tab.isDisabled || !tab.linkName ? 'button' : 'router-link'"
        @click="tab.isDisabled ? null : changeActiveTab(tab.id)"
        :to="!tab.isDisabled && tab.linkName ? { name: tab.linkName } : undefined"
        :aria-disabled="tab.isDisabled ? 'true' : 'false'"
        :tabindex="tab.isDisabled ? -1 : 0"
        :data-testid="`smartboost-tab-${tab.id}`"
        :class="[
          'tw:px-2 tw:py-3 tw:transition-colors tw:duration-200 tw:text-sm tw:border-b-[3px] tw:hover:no-underline',
          tab.isDisabled
            ? 'tw:text-gray-300 tw:cursor-not-allowed tw:border-transparent'
            : activeTab === tab.id
              ? 'tw:font-bold tw:text-blue-700 tw:border-blue-700 tw:cursor-pointer'
              : 'tw:text-gray-800 tw:hover:text-gray-300 tw:cursor-pointer tw:border-transparent tw:hover:border-gray-300',
        ]"
      >
        {{ $t(tab.label) }}
      </component>
    </div>

    <div class="tw:px-0 tw:pt-8">
      <slot :name="activeTab"></slot>
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits(['changeActiveTab'])
const changeActiveTab = id => emit('changeActiveTab', id)
defineProps({
  tabs: {
    type: Array,
    required: true,
  },
  defaultTab: {
    type: String,
    default: null,
  },
  activeTab: {
    type: String,
    default: '',
  },
})
</script>
